import { render } from "./BusinessTabs.vue?vue&type=template&id=75f3ff24"
import script from "./BusinessTabs.vue?vue&type=script&lang=js"
export * from "./BusinessTabs.vue?vue&type=script&lang=js"
script.render = render

export default script